<script lang="ts">
	import { DropdownMenu as DropdownMenuPrimitive } from 'bits-ui';
	import { cn } from '@ui-lib/utils/utils';

	type $$Props = DropdownMenuPrimitive.SeparatorProps;

	interface Props {
		class?: $$Props['class'];
		[key: string]: any
	}

	let { class: className = undefined, ...rest }: Props = $props();
	
</script>

<DropdownMenuPrimitive.Separator
	class={cn('bg-muted -mx-1 my-1 h-px', className)}
	{...rest}
/>
